import { createElementBlock as l, openBlock as o, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(a, e) {
  return o(), l("svg", n, e[0] || (e[0] = [
    t("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.069 7.334A.714.714 0 0 0 8 7.954v7.806c0 .549.592.893 1.069.62l.102-.058a1 1 0 0 1 .992 1.737l-.102.058C8.25 19.151 6 17.844 6 15.76V7.954c0-2.084 2.251-3.39 4.06-2.357l.103.059a1 1 0 0 1-.992 1.736zm2.986.555a1 1 0 0 1 1.365-.372L16.89 9.5c1.824 1.042 1.824 3.67 0 4.713l-3.471 1.984a1 1 0 0 1-.992-1.737l3.471-1.984a.714.714 0 0 0 0-1.24l-3.471-1.984a1 1 0 0 1-.373-1.364",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: r };
export {
  d as default,
  r as render
};
//# sourceMappingURL=ic_play_alt-CokVAYIq.js.map
